'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var bemReactClassname = require('bem-react-classname');
var themeProvider_themeProvider = require('../../theme-provider/theme-provider.js');
var cn = require('../../cn.js');
var core_copyright_copyright = require('../copyright/copyright.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var Footer = /** @class */ (function (_super) {
    tslib.__extends(Footer, _super);
    function Footer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cn = bemReactClassname.createCn('footer');
        return _this;
    }
    Footer.prototype.render = function () {
        var _a = this.props, id = _a.id, testId = _a["data-test-id"], theme = _a.theme, copyright = _a.copyright, showYears = _a.showYears, version = _a.version, target = _a.target;
        return (React__default.default.createElement("div", { className: this.cn(), id: id, "data-test-id": testId },
            React__default.default.createElement(themeProvider_themeProvider, { theme: theme },
                React__default.default.createElement("div", { className: this.cn('sub') }, copyright || (React__default.default.createElement(core_copyright_copyright.default, { target: target, version: version, showYears: showYears }))))));
    };
    Footer.defaultProps = {
        theme: 'alfa-on-white',
    };
    return Footer;
}(React__default.default.PureComponent));
/**
 * Компонент подвала сайта.
 * Обычно используется совместно с компонентом `Page`.
 * @visibleName Footer
 */
var footer = cn.withTheme(Footer);

exports.Footer = Footer;
exports.default = footer;
